<div class="flex flex-row min-h-full">
   <div class="w-[33px] m-0 z-50" [ngClass]="data.colore_scheda">
         <span class="p-1 mt-5 font-bold fixed" style=" writing-mode: vertical-lr; transform: rotate(180deg);">
            {{data.nome_scheda}}
         </span>
   </div>

   <div class="w-full h-[calc(100%-160px)]">
      <div class="flex mb-3 sticky top-0 z-30 w-full px-2 py-4 bg-white sm:px-4">
         <h2 class="flex-auto ml-5 font-bold">{{data.title}}</h2>

         <div class="justify-items-end">
            <button mat-dialog-close class="flex-auto" (click)="closeClick()"> <mat-icon>close</mat-icon></button>
         </div>
      </div>
      <div class="w-full p-3">
         <ng-container class="relative" *ngTemplateOutlet="data.templateRef; context:contextTemplate"></ng-container>
      </div>
   </div>

</div>

